import { render } from "./RelatorioProvisaoSinistrosView.vue?vue&type=template&id=4acef97c"
import script from "./RelatorioProvisaoSinistrosView.vue?vue&type=script&lang=js"
export * from "./RelatorioProvisaoSinistrosView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__